import { Text } from '@cmpsr/components';

type NavigationBarSelectedItemProps = {
  label: string;
};

export default function NavigationBarSelectedItem({ label }: NavigationBarSelectedItemProps) {
  return (
    <Text
      variant="text-body-medium"
      color="text-link-light-default"
      boxShadow="inset 0px -4px 0px 0px var(--chakra-colors-text-link-light-default)"
      px={4}
      py={7}
    >
      {label}
    </Text>
  );
}
